import { formatDateTimeLocalValue } from '../../utils/time'
import LabeledInput from './LabeledInput'

type DateTimeFieldProps = {
   id: string
   label: string
   value: string
   onValueInput: (value: string) => void
   /** Cap the picker at the current time (default true). */
   noFuture?: boolean
}

/**
 * Renders a labeled `datetime-local` input, capped at "now" unless told otherwise.
 *
 * @param props - Id, label, value, handler, and the future cap.
 * @returns The field element.
 */
const DateTimeField = (props: DateTimeFieldProps) => (
   <LabeledInput
      type="datetime-local"
      id={props.id}
      label={props.label}
      max={props.noFuture === false ? undefined : formatDateTimeLocalValue(Date.now())}
      value={props.value}
      onValueInput={props.onValueInput}
   />
)

export default DateTimeField
